import { set } from 'lodash';
import uuid from 'uuid/v4';
import {
    GA_SEND_PAGE_VIEW,
    sendPageView,
} from '../../middleware/pageView/actions';

export const preGa = (store) => (next) => (action) => {
    switch (action.type) {
        case GA_SEND_PAGE_VIEW: {
            set(window, 'ZD.configs.PAGE_ID', uuid());
            const pageViewEvent = {
                action: 'PageView',
            };
            store.dispatch(sendPageView(pageViewEvent));

            break;
        }
        default:
            break;
    }
    return next(action);
};
